import { useQuery } from "@tanstack/react-query";
import ticketsService from "services/admin/ticketsService";
import {
    ResponseTimeTrendParams,
    ResponseTimeTrendResponse,
} from "interfaces/entities/ticketStats";

type Options = { enabled?: boolean };

// Тренд среднего времени решения и первого ответа за N дней.
// Аналитический виджет: данные не «горячие», обновляются редко.
export const useResponseTimeTrend = (
    params: ResponseTimeTrendParams & { branchID?: number | string } = {},
    options: Options = {}
) => {
    const orgID = localStorage.getItem("orgID") || "";
    const { enabled = true } = options;

    return useQuery<ResponseTimeTrendResponse>({
        queryKey: ["tickets-response-time-trend", orgID, params],
        queryFn: async () => {
            const response = await ticketsService.getResponseTimeTrend(params);
            return response.data;
        },
        enabled,
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
};
